import { render, staticRenderFns } from "./SpacesList.vue?vue&type=template&id=fc872586"
import script from "./SpacesList.vue?vue&type=script&lang=js"
export * from "./SpacesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports